import { useContext } from 'react';

import { ActiveTabsCtx } from '../contexts/ActiveTabsCtx';

export const useActiveTabs = () => useContext(ActiveTabsCtx);
